import { useCallback, useEffect, useState } from 'react';
import AuthService from '../../application/services/AuthService';

/**
 * React-idiomatic equivalent of getspeakhub-portal's `AuthService.isAuthenticated$`
 * observable — subscribes to the same TokenStorage change notifications so any
 * component using this hook re-renders the moment login/logout/refresh happens.
 */
export function useAuth() {
  const [isAuthenticated, setIsAuthenticated] = useState(() => AuthService.isAuthenticated());

  useEffect(() => {
    return AuthService.subscribe(() => setIsAuthenticated(AuthService.isAuthenticated()));
  }, []);

  const login = useCallback((returnTo?: string) => AuthService.beginLogin(returnTo), []);
  const logout = useCallback(() => AuthService.logout(), []);

  return { isAuthenticated, login, logout };
}
